import { HeroBanner } from 'components/HeroBanner';
import { HeroWrapperContainer } from './HeroWrapperContainer';
import { HeroContainer, Background } from './styles';

import type {
  BannerContentAlignment,
  BannerContentVerticalAlignment,
  IImage,
  TextColorHeroBanner,
} from 'components/HeroBanner/types';
import { AVAILABLE_THEMES } from '@/styles/constants';
import { useGlobalContext } from '../Context/hooks/useGlobalContext';

export interface IAsset {
  width: number;
  mobile?: string;
  desktop?: string;
  tablet?: string;
  image?: string;
  hero?: string;
  mimeType?: string;
}

export interface IImageComponent {
  asset: IImage[];
}

export interface IHero {
  textColor?: TextColorHeroBanner;
  primarySubBrandColor?: string;
  topRightImageAsset?: IAsset;
  bottomLeftImageAsset?: IAsset;
  title?: string | null;
  alignment?: string | null;
  verticalAlignment?: string | null;
  verticalAlignmentMobile?: string | null;
  description?: string | null;
  imageComponent?: IImageComponent;
  mobileImage?: IAsset;
  superText?: string | null;
}

// for now we cast the props as it would be too much to change every type for hero banner
export const Hero = ({
  topRightImageAsset,
  bottomLeftImageAsset,
  title,
  alignment,
  verticalAlignment,
  verticalAlignmentMobile,
  description,
  imageComponent,
  mobileImage,
  superText,
  textColor,
  primarySubBrandColor,
}: IHero) => {
  const { themeName } = useGlobalContext();
  return (
    <HeroWrapperContainer
      data-test="hero-wrapper-container"
      topRightImage={themeName === AVAILABLE_THEMES.suprema ? undefined : topRightImageAsset}
      bottomLeftImage={themeName === AVAILABLE_THEMES.suprema ? undefined : bottomLeftImageAsset}
    >
      <Background className="curve-mask-top " $customColor={primarySubBrandColor || '#EFDBB2'}>
        <div className="curve-mask-bottom">
          <HeroContainer data-test="hero-container">
            <HeroBanner
              data-test="hero-banner"
              bannerSize="Short"
              priority
              title={title as string}
              alignment={alignment as BannerContentAlignment}
              verticalAlignment={verticalAlignment as BannerContentVerticalAlignment}
              verticalAlignmentMobile={verticalAlignmentMobile as BannerContentVerticalAlignment}
              description={description as string}
              image={imageComponent?.asset?.[0] as IImage}
              mobileImage={mobileImage as Record<string, string> | undefined}
              superText={superText as string}
              textColor={textColor}
            />
          </HeroContainer>
        </div>
      </Background>
      <div className="md:mb-20 hero-wrapper-container-bottom-spacer" />
    </HeroWrapperContainer>
  );
};
